import { useTranslation } from 'next-i18next'

export const useCheckPasswordMatch = () => {
  const { t } = useTranslation()

  return (value: string, confirmPassword: string) => {
    if (!value) return t('login.validation.password')
    if (value !== confirmPassword) return t('resetting.form.password.mismatch')
  }
}
